import type { DiscoverConfig, DiscoverDataSource } from "@majourneys/discover";
import { useDisplayPrice } from "@majourneys/currency";
import {
  fetchMajourneysDiscoverIndex,
  fetchDiscoverDetail,
  getInitialDiscoverItems,
} from "./api/majourneys-activities";
import { DiscoverChat } from "./components/discover-chat";
import { useTripBooking } from "./hooks/use-trip-booking";
import { useDiscoverSaved } from "./hooks/use-discover-saved";

/**
 * The 3D category art the home rail shows (each category's icon in the
 * catalogue), reused on the Discover sheet's category row. Attractions, Golf,
 * Nightlife and Beach clubs have no category art on the site, so they borrow
 * the app's (packages/assets, scaled to 96px) by owner's choice, 2026-10-26.
 */
const CF = "https://imagedelivery.net/9h9OrUsEhPYeYHCr6DaDTQ";
const bucketArt: DiscoverConfig["bucketArt"] = {
  "things-to-do": `${CF}/a2425edc-853e-4555-0591-dcf45959a800/public`,
  restaurants: `${CF}/623f0bce-783a-4ba4-ccae-e2cc5e560500/public`,
  stays: `${CF}/c00aa7f4-145d-4175-c1ef-ac6b2c1a2800/public`,
  spas: `${CF}/ea58463e-22da-4221-104b-d4bcc8112900/public`,
  locations: "/images/subcategories/cat-attractions.png",
  golf: "/images/subcategories/cat-golf.png",
  nightlife: "/images/subcategories/cat-nightlife.png",
  "beach-clubs": "/images/subcategories/cat-beach-clubs.png",
};

const dataSource: DiscoverDataSource = {
  fetchIndex: (lang) => fetchMajourneysDiscoverIndex(lang),
  fetchDetail: (slug, lang) => fetchDiscoverDetail(slug, lang),
  getInitialItems: () => getInitialDiscoverItems(),
};

export const majourneysDiscoverConfig: DiscoverConfig = {
  dataSource,
  features: { aiChat: <DiscoverChat /> },
  // Discover prices follow the currency the guest picked in the header.
  usePrice: useDisplayPrice,
  // A trip's day goes into the same bucket the booking sheet fills.
  useTripBooking,
  // Discover hearts and /liked read the site's saved list, not one of their own.
  useSaved: useDiscoverSaved,
  bucketArt,
};
